import { render, staticRenderFns } from "./ResultContent.vue?vue&type=template&id=c4975406&"
import script from "./ResultContent.vue?vue&type=script&lang=js&"
export * from "./ResultContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports